import { StudentResultsStore } from "../../../react/students/StudentResultsStore"
import { EveryCigBodyPart, EveryCigMovieStore } from "./EveryCigTypes"


export class EveryCigStore {
    private static innerInstance: EveryCigStore

    private store: EveryCigMovieStore = {
        parts: [],
        voteAudio: false,
        viewVotesAudio: false
    }

    // noinspection JSUnusedLocalSymbols
    private constructor(
        private everyCigChoiceTotals?: Map<EveryCigBodyPart, number>
    ) {}

    static get instance() {
        return this.innerInstance || (this.innerInstance = new this())
    }

    static newInstance() {
        return this.innerInstance = new this()
    }

    get parts() {
        return this.store.parts
    }

    set part(p: EveryCigBodyPart) {
        if (!this.store.parts.includes(p)) {
            this.store.parts.push(p)
        }
    }

    get selected(): EveryCigBodyPart {
        return this.store.selected
    }

    set selected(s: EveryCigBodyPart) {
        this.store.selected = s
    }

    get voteAudio(): boolean {
        return this.store.voteAudio
    }

    set voteAudio(v: boolean) {
        this.store.voteAudio = v
    }

    get viewVotesAudio(): boolean {
        return this.store.viewVotesAudio
    }

    set viewVotesAudio(v: boolean) {
        this.store.viewVotesAudio = v
    }

    static getVoteTotals = (): Map<string, number> => {
        const choices = StudentResultsStore.instance.findEveryCigChoices()

        const everyCigChoiceTotals = new Map([
            [ EveryCigBodyPart.BRAIN, 0 ], [ EveryCigBodyPart.EYE, 0 ], [ EveryCigBodyPart.HEART, 0, ], [ EveryCigBodyPart.LUNGS, 0 ]
        ])
        if (choices == null) {
            return everyCigChoiceTotals
        } else {
            choices.map(choice => {
                everyCigChoiceTotals.set(choice, everyCigChoiceTotals.get(choice) + 1)
            })
            return everyCigChoiceTotals
        }
    }

    static getTopVoted = (): string => {
        const votes = EveryCigStore.getVoteTotals()

        let topVoted = EveryCigBodyPart.BRAIN
        if (votes.get(EveryCigBodyPart.EYE) > votes.get(topVoted)) {
            topVoted = EveryCigBodyPart.EYE
        }
        if (votes.get(EveryCigBodyPart.HEART) > votes.get(topVoted)) {
            topVoted = EveryCigBodyPart.HEART
        }
        if (votes.get(EveryCigBodyPart.LUNGS) > votes.get(topVoted)) {
            topVoted = EveryCigBodyPart.LUNGS
        }

        return topVoted
    }
}
